<template>
  <div>
    <el-dialog :visible.sync="mouthShow" :title="title" class="el-allData" @close="hideExport">
      <dimension
        :tabNames="tabNames"
        :dateSeparator="dateSeparator"
        :autoChunkMonth="autoChunkMonth"
        :isSingleSelect="false"
        :openType="'dialog'"
        :moduleName="moduleName"
        :provinceName="provinceName"
        :provinCode="provinCode"
        :pathwayCityCode="pathwayCityCode"
        :cityName="cityName"
        :params="params"
        :tab="tab"
        :moduleType="moduleType"
        :oilBrand="oilBrand"
        :condition="condition"
        :roadCode="roadCode"
        :toExportDetail="toExportDetail"
        :beforeExportFunc="beforeExportFunc"
        @hideExport="hideExport"/>
    </el-dialog>
  </div>
</template>
<script>
//增加多维导出公共对话框
import dimension from './index.vue'
import map from 'lodash/map'
import get from 'lodash/get'
import find from 'lodash/find'
import includes from 'lodash/includes'
import each from 'lodash/each'
import split from 'lodash/split'
import size from 'lodash/size'

export default {
  components: {
    dimension,
  },
  props: {
    dateSeparator: {
      type: String,
      default: "-"
    },
    params:{
      type:Object,
      default(){
        return {}
      }
    },
    autoChunkMonth: {//自动拆分月
      type: Boolean,
      default: false
    },
    tabNames: {//容许 显示的tab name
      type: String,
      default: 'monthly|quarterly|semi-annual|annual'
    },
    showTab: {//是否显示tab
      type: Boolean,
      default: true
    },
    title: {//容许 显示的tab name
      type: String,
      default: '请选择您需要导出数据'
    },
    moduleName: {
      type: String,
      default: ''
    },
    provinceName: {
      type: String
    },
    provinCode: {
      type: String
    },
    pathwayCityCode: {
      type: String
    },
    cityName: {
      type: String
    },
    tab: {
      type: Number
    },
    oilBrand: {
      type: String
    },
    condition: {
      type: String
    },
    roadCode: {
      type: String
    },
    moduleType: {
      type: String
    },
    toExportDetail: {
      type: [Function, String],
      default: ''
    },
    beforeExportFunc: {
      type: Function,
      default: () => true
    },
  },
  data() {
    return {
      mouthShow:true,
    }
  },
  mounted() {
  },
  created() {
  },
  beforeDestroy() {},
  computed: {
  },
  methods: {
    hideExport() {
      this.$emit('hideExport')
    },
  }
}
</script>
